import { BoxProps } from '@mui/material';
import CustomAutoCompleteIndex from './CustomAutoCompleteIndex';
import { useMemo } from 'react';

type ProgramFilterProps = {
    programName: string;
    setProgramName: React.Dispatch<React.SetStateAction<string>>;
    programOptionsList: string[];
    handleChange?: (
        value: { label: string; value: string; displayLabel: string } | null
    ) => void;
    handleProgramInputChange?: (value: string) => void;
    boxProps?: BoxProps;
};

const programFilter = {
    backgroundColor: '#003771',
    // position: 'fixed',
    right: '215px',
    minWidth: '210px !important',
    '& fieldset': {
        display: 'none',
    },
};

const inputSx = {
	'& .MuiInputBase-root': {
		padding: 0, 
		'& .MuiAutocomplete-input': {
			fontSize: '15px',
			padding: '10px 4px 10px 8px',
		},
	},
};

const ProgramFilter = ({ 
    programName,
    setProgramName,
    programOptionsList,
    handleChange,
    handleProgramInputChange,
}: ProgramFilterProps) => {
    const options = useMemo(() => [
        { label: 'All Programs', value: 'all', displayLabel: 'All Programs' },
        ...programOptionsList.map((option) => ({
            label: option,
            value: option,
            displayLabel: option.length > 25 ? option.substring(0, 25) + '...' : option,
        })),
    ], [programOptionsList]);

    return (
        <CustomAutoCompleteIndex
            textFieldLabel={''}
            inputValue={programName}
            value={options.find(opt => opt.value === programName) || null}
            onChange={(_, selectedOption) => {
                if (selectedOption) {
                    setProgramName(selectedOption.value);  
                    handleChange?.(selectedOption);
                }
            }}
            onInputChange={(event, inputText, reason) => {
                if (reason === 'input') {
                    handleProgramInputChange?.(inputText);
                }
            }}
            columnName={'ProgramFilter'}
            options={options}
            boxProps={{
                sx: programFilter,
            }}
            componentsProps={{
                paper: {
                    sx: {
                    	fontSize: '12px',
                    },
                },
            }}
            inputSx={inputSx}    
        />
    );
};

export default ProgramFilter;
